import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "HotSearchViewContainer"
};
const _hoisted_2 = {
  key: 0,
  src: "https://cdn.waityou.online/736652c6-a95c-f436-1dc5-4b44507142ca.png",
  class: "sqr16 mr6"
};
const _hoisted_3 = {
  key: 1,
  src: "https://cdn.waityou.online/53543ff1-c94a-8357-9be6-3cbdcf9315b9.png",
  class: "sqr16 mr6"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
          "table-id": 11,
          "init-query": {
            siteId: site.value
          }
        }, {
          hotSearchTag: _withCtx(data => [data.rowData == 'HOT' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), data.rowData == 'NEW' ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["init-query"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]);
}